import 'src/global.css';

// ----------------------------------------------------------------------

import { Toaster } from 'sonner';

import { Router } from 'src/routes/sections';

import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import { ThemeProvider } from 'src/theme/theme-provider';

import { ProgressBar } from 'src/components/progress-bar';
import { MotionLazy } from 'src/components/animate/motion-lazy';
import { SettingsDrawer, defaultSettings, SettingsProvider } from 'src/components/settings';

import { AuthProvider } from 'src/auth/context/firebase';

import { I18nProvider, LocalizationProvider } from './locales';
import { EventSourceProvider } from './contexts/event-source-context';
import { MediaUpdatesProvider } from './contexts/media-updates-context';
import { WorkspaceProvider } from './components/workspace/workspace-provider';

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();

  return (
    <I18nProvider>
      <LocalizationProvider>
        <AuthProvider>
          <WorkspaceProvider>
            <SettingsProvider settings={defaultSettings}>
                <EventSourceProvider>
                  <MediaUpdatesProvider>
                    <ThemeProvider>
                      <Toaster position="top-right" duration={2000} />
                      <MotionLazy>
                        <ProgressBar />
                        <SettingsDrawer />
                        <Router />
                      </MotionLazy>
                    </ThemeProvider>
                  </MediaUpdatesProvider>
                </EventSourceProvider>
            </SettingsProvider>
          </WorkspaceProvider>
        </AuthProvider>
      </LocalizationProvider>
    </I18nProvider>
  );
}
